import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import DeviceStatusProvider from './components/runningtrack/DeviceStatusProvider';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter } from 'react-router-dom';
import rootReducer, { rootSaga } from './modules/index';
import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import createSagaMiddleware from 'redux-saga';
import { composeWithDevTools } from 'redux-devtools-extension';
import { tempSetUser, check } from './modules/user';
import { tempSetClubs } from './modules/clubs/clubs';
import { tempSetClub } from './modules/clubs/club';
import { setSocketKey } from './modules/socket/socket';
import { DndProvider } from 'react-dnd';
import Backend from 'react-dnd-html5-backend';

const sagaMiddleware = createSagaMiddleware();
const store = createStore(
  rootReducer,
  composeWithDevTools(applyMiddleware(sagaMiddleware)),
);

function loadUser() {
  try {
    const user = localStorage.getItem('user');
    const clubs = localStorage.getItem('clubs');
    const defaultClub = localStorage.getItem('club');
    const socketKey = localStorage.getItem('socketKey');

    // 이쪽에서 클럽 전체 로드 처리

    store.dispatch(setSocketKey(JSON.parse(socketKey)));
    store.dispatch(tempSetUser(user));
    store.dispatch(check(JSON.parse(user)));
    store.dispatch(tempSetClub(JSON.parse(defaultClub)));
    store.dispatch(tempSetClubs(JSON.parse(clubs)));
  } catch (e) {
    console.log('localStorage is not working.');
  }
}

sagaMiddleware.run(rootSaga);
loadUser();

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <DndProvider backend={Backend}>
        <DeviceStatusProvider><App /></DeviceStatusProvider>
      </DndProvider>
    </BrowserRouter>
  </Provider>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
